import { render, staticRenderFns } from "./Person26y.vue?vue&type=template&id=ed83e2a0"
import script from "./Person26y.vue?vue&type=script&lang=js"
export * from "./Person26y.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports